<mat-card appearance="outlined">
    <mat-card-content>
        <div class="mfa-banner-content">
            <mat-icon fontSet="material-symbols-outlined" class="warning">warning</mat-icon>
            <span class="mfa-banner-text">Haven't set up MFA yet? We highly recommend doing so now to safeguard your
                account. Click "<strong>Setup 2FA</strong>" from the menu and protect your information.</span>
            <button mat-stroked-button class="icon-only" (click)="supressMfaReminder()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </mat-card-content>
</mat-card>